<div class="col-xs-12 col-md-5 col-lg-4" *ngIf="enableCloseButton$ | async">
    <button #element class="btn btn-block btn-secondary" (click)="openDialog()">
      {{ 'customerTicketingDetails.closeRequest' | cxTranslate }}
    </button>
  </div>
  